import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { usePassCallingComponentPositionProps } from '../hooks';
import { CallingNavComponentIcon } from './CallingNavComponentIcon';
import { useDndWidget } from '../../common/hooks/useDndWidget';
import { CALLING_COMPONENT } from 'navigation-components/config';
import { jsx as _jsx } from "react/jsx-runtime";
const CallingRemote = memoWithDisplayName('CallingRemote', () => {
  usePassCallingComponentPositionProps();
  useDndWidget(CALLING_COMPONENT);
  return /*#__PURE__*/_jsx(CallingNavComponentIcon, {});
});
export default CallingRemote;